<template>
  <div v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK)" class="spl-book-parcel">
    <subpage-header back-link="parcel-list" label="Book a new parcel" />

    <div class="spl-edit-template__step-header-holder">
      <div class="spl-edit-template__step-header">
        <div
          v-for="(step, index) in steps"
          :key="'parcelBookStep'+index"
          :class="{'spl-edit-template__step-header__step-active': currentStep === index, 'spl-edit-template__step-header__step-valid': step.ref && step.ref.isValid()}"
          class="spl-edit-template__step-header__step"
          @click="showStep(index)">
          {{ step.label }}
        </div>
      </div>
    </div>

    <div class="spl-edit-template">
      <!-- *********************** STEP 1: General Information Section  *********************************** -->
      <booking-general-information
        v-show="currentStep === 0"
        ref="generalInformation"
        :next-step-label="getNextStepLabel(0)"
        :booking-data="bookingData"
        :return-parcel="selectedReturnParcel"
        booking-type="parcel"
        @contactsLoaded="onContactsLoaded"
        @nextStep="onNextStep"
        @copyFromReturn="onCopyFromReturn" />

      <!-- *********************** STEP 2: Address & Contact Section  *********************************** -->
      <booking-address
        v-show="currentStep === 1"
        ref="address"
        :next-step-label="getNextStepLabel(1)"
        :booking-data="bookingData"
        @previousStep="onPreviousStep"
        @nextStep="onNextStep" />

      <!-- *********************** STEP 3: Parcel Details Section  *********************************** -->
      <booking-parcel-details
        v-show="currentStep === 2"
        ref="parcelDetails"
        :next-step-label="getNextStepLabel(2)"
        :booking-data="bookingData"
        @nextStep="onNextStep" />

      <!-- *********************** Additional References  *********************************** -->
      <booking-additional-references
        v-show="currentStep === 3"
        ref="additionalReferences"
        :next-step-label="getNextStepLabel(3)"
        :booking-data="bookingData"
        @nextStep="onNextStep" />

      <!-- *********************** STEP 4: Additional Information  *********************************** -->
      <booking-additional-informations
        v-show="currentStep === 4"
        ref="additionalInformations"
        :next-step-label="getNextStepLabel(4)"
        :booking-data="bookingData"
        :is-booking="isBooking"
        @save="onSave"
        @cancel="onCancel" />
    </div>

    <!-- *********************** Message Modal *********************************** -->
    <message-modal />
    <!-- *********************** Book Success Modal *********************************** -->
    <parcel-book-success-modal @book_More_Clicked="book_More" @see_Parcel_Details_Clicked="see_Parcel_Details" />
    <return-parcel-select-modal
      :is-visible="returnParcels.length > 0"
      :parcels="returnParcels"
      @cancel="onReturnParcelSelectCancel"
      @parcelSelcted="onReturnParcelSelected" />

    <div v-if="isBooking" class="spl-load-img" />
  </div>
</template>

<script>
import webApi from '@/webApi'
import Helpers from '@/helpers.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { unionBy, findIndex, merge, find, cloneDeep } from 'lodash'
import constants from '@/constants'
import QuestionDialog from '@/components/shared/question-dialog.vue'
import { create } from 'vue-modal-dialogs'

const confirm = create(QuestionDialog, 'title', 'content', 'positiveText', 'negativeText')

export default {
  name: 'ParcelBook',
  mixins: [Helpers],
  data () {
    return {
      isBooking: false,
      profileData: {},
      bookingData: {
        book_parcel_model: {
          Customer_ID: -1,
          Country_ID: -1,
          Service_Level_ID: -1,
          Pickup_Address_ID: -1,
          Delivery_Address_ID: -1,
          pickup_address_object: {},
          delivery_address_object: {},
          pickup_address_formatted: '',
          delivery_address_formatted: '',
          Contact: {
            Active: true,
            Contact_ID: -1,
            Contact_Name: '',
            Phone_Number: ''
          },
          Booked_Pickup_Date: new Date(),
          Is_Forward: true,
          References: [
            {
              Reference_Type_ID: constants.REFERENCE_TYPE_ID.COUNTER_NUMBER,
              Reference_Text: ''
            }
          ],
          Weight: 0,
          Volume: 0,
          Length: 0,
          Width: 0,
          Height: 0,
          XRayed: false,
          Last_Mile_Upgrade: false,
          Original_Parcel_ID: null,
          Dangerous_Goods: false,
          Loading_List: '',
          Delivery_Information: ''
        },
        saveOptions: {},
        additional_references_list: [],
        contact_list: []
      },
      returnParcels: [],
      selectedReturnParcel: null,
      currentStep: 0,
      stepElems: null,
      headerHolder: null,
      constants,
      parcel_id: -1,
      dialogOpen: false,
      steps: [
        {
          ref: null,
          label: 'General Information'
        },
        {
          ref: null,
          label: 'Address Details'
        },
        {
          ref: null,
          label: 'Parcel Details'
        },
        {
          ref: null,
          label: 'Additional References'
        },
        {
          ref: null,
          label: 'Add Notes & Save'
        }
      ]
    }
  },

  computed: {
    ...mapGetters('user', ['getCountryPermissions', 'getCustomerPermissions']),
    ...mapGetters('reference', ['emptyReferenceValues']),
    ...mapGetters('profiler', ['profileList']),
    ...mapState('reference', ['references'])
  },

  mounted () {
    if (this.getCountryPermissions.length === 1) {
      this.bookingData.book_parcel_model.Country_ID = this.getCountryPermissions[0]
    }
    if (this.getCustomerPermissions.length === 1) {
      this.bookingData.book_parcel_model.Customer_ID = this.getCustomerPermissions[0]
    }
    this.get_Reference_Types()
    this.steps[0].ref = this.$refs.generalInformation
    this.steps[1].ref = this.$refs.address
    this.steps[2].ref = this.$refs.parcelDetails
    this.steps[3].ref = this.$refs.additionalReferences
    this.steps[4].ref = this.$refs.additionalInformations
    this.headerHolder = this.$el.querySelector('.spl-edit-template__step-header-holder')
    this.stepElems = this.$el.querySelectorAll('.spl-edit-template__step')
    if (this.$route.params && this.$route.params.return_id) {
      this.bookingData.book_parcel_model.Is_Forward = false
      this.onCopyFromReturn(this.$route.params.return_id)
    }
    this.$watch(vm => [vm.bookingData.book_parcel_model.Country_ID, vm.bookingData.book_parcel_model.Customer_ID, vm.bookingData.book_parcel_model.Is_Forward], val => {
      if (this.bookingData.book_parcel_model.Country_ID !== -1 && this.bookingData.book_parcel_model.Customer_ID !== -1) {
        this.getProfiler(this.bookingData.book_parcel_model.Customer_ID, this.bookingData.book_parcel_model.Country_ID, this.bookingData.book_parcel_model.Is_Forward)
      }
    },
    {
      immediate: true,
      deep: true
    })
  },

  methods: {
    ...mapActions(['resetContacts']),
    ...mapActions('profiler', ['loadProfiler']),
    ...mapActions('reference', ['reset', 'loadReferences']),
    // ************************ Save the parcel ************************
    onSave (bookingData) {
      this.isBooking = true
      merge(this.bookingData, bookingData)

      var createCmrModel = {
        Parcel_IDs: [],
        Create_CMR: bookingData.saveOptions.Create_CMR,
        Create_Delivery_Note: bookingData.saveOptions.Create_Delivery_Note,
        Create_Loading_List: bookingData.saveOptions.Create_Loading_List
      }

      var counterNumberIndex = findIndex(this.bookingData.book_parcel_model.References, { Reference_Type_ID: constants.REFERENCE_TYPE_ID.COUNTER_NUMBER })
      if (counterNumberIndex !== -1 && this.bookingData.book_parcel_model.References[counterNumberIndex].Reference_Text && this.bookingData.book_parcel_model.References[counterNumberIndex].Reference_Text.toUpperCase) {
        this.bookingData.book_parcel_model.References[counterNumberIndex].Reference_Text = this.bookingData.book_parcel_model.References[counterNumberIndex].Reference_Text.toUpperCase()
      }

      var bookParcelModel = {
        Book_Parcel_Model: this.bookingData.book_parcel_model,
        Create_CMR_Model: createCmrModel,
        Send_Mail_To: bookingData.saveOptions.Email
      }

      webApi.parcel.book_Parcel(bookParcelModel)
        .then((response) => {
          // Open the created parcel
          var responeModel = response.data
          this.parcel_id = responeModel.Parcel_IDs[0]
          var documentId = responeModel.Document_ID
          if (documentId > 0) {
            this.downloadDocument(documentId)
            window.bus.$emit(
              constants.BUS_EVENTS.OPEN_BOOK_SUCCESS_MODAL,
              'The parcel was booked. It might take some time to load the generated documents. They can also e found in parcel details.',
              constants.BUS_KEYS.BOOK_SUCCESS_MODAL_TYPE_PARCEL
            )
          } else {
            window.bus.$emit(constants.BUS_EVENTS.OPEN_BOOK_SUCCESS_MODAL, 'The parcel was booked.', constants.BUS_KEYS.BOOK_SUCCESS_MODAL_TYPE_PARCEL)
          }
          this.isBooking = false
        }).catch((response) => {
          this.isBooking = false
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },

    onCancel () {
      this.$router.go(-1)
    },

    onNextStep (bookingData) {
      merge(this.bookingData, bookingData)
      this.currentStep++
    },
    onPreviousStep (bookingData) {
      merge(this.bookingData, bookingData)
      this.currentStep -= 1
    },
    onCopyFromReturn (parcelID) {
      // searches for a parcel that will be used as a base to be copied into the return parcel
      webApi.parcel.search_Parcel_By_Reference(parcelID)
        .then((response) => {
          if (response && response.data) {
            if (response.data.length === 1) {
              var foundParcel = response.data[0]
              // gets the detail since we need some information from it that is not included in the search result
              webApi.parcel.get_Parcel_Details_By_ID(foundParcel.Parcel_ID).then((response) => {
                var parcelData = response.data
                // TODO Check if it has a Return_Parcel_ID then show error
                this.checkReturnParcel(parcelData)
              }).catch((error) => {
                window.bus.$emit('openErrorModal', 'Error Copying Return Data from Parcel' + error.data.ExceptionMessage)
              })
            } else if (response.data.length > 1) {
              this.returnParcels = response.data
            } else if (response.data.length === 0) {
              window.bus.$emit('openWarningModal', 'No parcel found with this reference.')
            }
            // Sample references
            // TM12345
            // SIM410104047801
            // AT0000037058A
            // SIM410104054492001
          }
        }).catch((error) => {
          window.bus.$emit('openErrorModal', 'Error Copying Return Data from Parcel' + error.data.ExceptionMessage)
        })
    },
    async checkReturnParcel (parcelData) {
      if (parcelData.Return_Parcel_ID !== -1) {
        if (this.dialogOpen) {
          return
        }
        this.dialogOpen = true
        if (await confirm('Return parcel already exists', '', 'Go to return', 'Cancel')) {
          this.$router.push('/parcel-detail/' + parcelData.Return_Parcel_ID)
          this.$router.go()
          this.dialogOpen = false
        } else {
          this.dialogOpen = false
        }
      } else {
        this.fillBookingData(parcelData)
      }
    },
    async fillBookingData (parcelData) {
      // Fill al the data of the selected return parcel
      this.selectedReturnParcel = parcelData
      this.bookingData.book_parcel_model.Customer_ID = parcelData.Customer_ID
      this.bookingData.book_parcel_model.Country_ID = parcelData.Country_ID
      this.bookingData.book_parcel_model.Service_Level_ID = parcelData.Service_Level_ID
      this.$refs.address.addFoundAddress(parcelData.Delivery_Address, 'pickup')
      this.$refs.address.addFoundAddress(parcelData.Pickup_Address, 'delivery')
      this.bookingData.book_parcel_model.Pickup_Address_ID = parcelData.Delivery_Address_ID
      this.bookingData.book_parcel_model.Delivery_Address_ID = parcelData.Pickup_Address_ID
      this.bookingData.book_parcel_model.Height = parcelData.Height
      this.bookingData.book_parcel_model.Weight = parcelData.Weight
      this.bookingData.book_parcel_model.Volume = parcelData.Volume
      this.bookingData.book_parcel_model.Length = parcelData.Length
      this.bookingData.book_parcel_model.Width = parcelData.Width
      this.bookingData.book_parcel_model.XRayed = parcelData.XRayed
      this.bookingData.book_parcel_model.Last_Mile_Upgrade = parcelData.Last_Mile_Upgrade
      this.bookingData.book_parcel_model.Original_Parcel_ID = parcelData.Parcel_ID
      this.bookingData.book_parcel_model.Dangerous_Goods = parcelData.Dangerous_Goods

      await this.getProfiler(this.bookingData.book_parcel_model.Customer_ID, this.bookingData.book_parcel_model.Country_ID, this.bookingData.book_parcel_model.Is_Forward)
      var profilelist = JSON.parse(window.sessionStorage.getItem('Profiler_List'))
      this.bookingData.book_parcel_model.References.forEach((reference) => {
        var sourceReference = find(parcelData.References, { Reference_Type_ID: reference.Reference_Type_ID })
        var copyReference = true
        if (profilelist !== null && Object.prototype.hasOwnProperty.call(profilelist, 'Fields')) {
          const found = profilelist.Fields.find(el => el.Name.toLowerCase() === reference.Reference_Type_Name.toLowerCase())
          if (found) {
            copyReference = found.CopyValues
          }
        }
        if (sourceReference && copyReference) {
          reference.Reference_Text = sourceReference.Reference_Text
        }
        if (reference.Reference_Type_ID === constants.REFERENCE_TYPE_ID.FORWARD_COUNTER_NUMBER && this.bookingData.book_parcel_model.Is_Forward === false && copyReference) {
          reference.Reference_Text = find(parcelData.References, { Reference_Type_ID: constants.REFERENCE_TYPE_ID.COUNTER_NUMBER }).Reference_Text
        }
        if (!copyReference && sourceReference) {
          reference.Reference_Text = ''
          sourceReference.Reference_Text = ''
        }
      })
      this.bookingData.book_parcel_model.References = unionBy(this.bookingData.book_parcel_model.References, parcelData.References, 'Reference_Type_ID')
      this.$forceUpdate()
    },
    getProfiler (customer_id, country_id, is_forward) {
      var profileFilter = { Customer_ID: customer_id, Country_ID: country_id, Is_Forward: is_forward }
      this.loadProfiler(profileFilter).then(() => {
        var list = window.sessionStorage.getItem('Profiler_List')
        this.profileData = JSON.parse(JSON.parse(JSON.stringify(list)))
      }).catch((error) => {
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    },
    // cancels the select modal
    onReturnParcelSelectCancel () {
      this.returnParcels = []
    },

    // If multiple parcels are available to select for return copying show a modal
    onReturnParcelSelected (parcelID) {
      this.returnParcels = []
      webApi.parcel.get_Parcel_Details_By_ID(parcelID).then((response) => {
        var parcelData = response.data
        this.selectedReturnParcel = parcelData
        this.checkReturnParcel(parcelData)
      }).catch(() => {
        window.bus.$emit('openErrorModal', 'Could not get Return Parcel')
      })
    },

    onContactsLoaded () {
      if (this.selectedReturnParcel && this.selectedReturnParcel.Contact_ID && this.selectedReturnParcel.Contact_ID !== -1) {
        this.bookingData.book_parcel_model.Contact.Contact_ID = this.selectedReturnParcel.Contact_ID
      }
    },

    // ************************ Get the reference types ************************
    // Gets all the reference types and adds them to the book model, except the counter number

    get_Reference_Types () {
      this.bookingData.book_parcel_model.References = this.emptyReferenceValues
      this.bookingData.additional_references_list = this.references
    },
    // ***************** downloads CMR / Delivery Note / Loading list ******************************
    downloadDocument (documentId) {
      webApi.document.download_Document(documentId)
        .then((response) => {
          // Cypress headless fix
          if (window.Cypress) {
            return
          }
          /*eslint-disable */
          // First look for the file name in the header
          var filename = 'CMR_' + this.parcel_id + '.pdf'

          // From the returned file stream we create a blob
          var blob = new Blob([response.data], { type: 'application/octet-stream' })

          // Open the blob to be downloaded, for  IE we need  a special way of opening it
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, filename)
          } else {
            var typeParams = {}
            typeParams["type"] = "text/plain"
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, typeParams)
            a.download = filename
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
          /* eslint-enable */
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },
    //* ************** We want to book more parcels. Move to first step, but keep the options **********************/
    book_More () {
      // Reset the steps
      this.currentStep = 0
      var tempBookingData = cloneDeep(this.bookingData)
      // Reset the parcel (but save the some options)

      if (tempBookingData.book_parcel_model.Is_Forward) {
        // Forwards parcel normally have the same pickup, but different delivery
        tempBookingData.book_parcel_model.Delivery_Address_ID = -1
        tempBookingData.book_parcel_model.Contact = {
          Active: true,
          Contact_ID: -1,
          Contact_Name: '',
          Phone_Number: ''
        }
        tempBookingData.delivery_address_object = {}
        tempBookingData.delivery_address_formatted = ''
      } else {
        // Return parcel normally have different pickup, but same delivery
        tempBookingData.book_parcel_model.Pickup_Address_ID = -1
        tempBookingData.pickup_address_object = {}
        tempBookingData.pickup_address_formatted = ''
      }

      this.parcel_id = -1
      tempBookingData.book_parcel_model.References[0].Reference_Text = ''
      for (let i = 0; i < tempBookingData.book_parcel_model.References.length; i++) {
        tempBookingData.book_parcel_model.References[i].Reference_Text = ''
      }
      tempBookingData.book_parcel_model.Weight = ''
      tempBookingData.book_parcel_model.Volume = ''
      tempBookingData.book_parcel_model.Length = ''
      tempBookingData.book_parcel_model.Width = ''
      tempBookingData.book_parcel_model.Height = ''
      tempBookingData.book_parcel_model.Original_Parcel_ID = null
      tempBookingData.book_parcel_model.XRayed = false
      tempBookingData.book_parcel_model.Last_Mile_Upgrade = false
      tempBookingData.book_parcel_model.Dangerous_Goods = false
      tempBookingData.book_parcel_model.Loading_List = ''
      this.bookingData = tempBookingData
      this.$refs.generalInformation.reset()
      this.$refs.address.reset(tempBookingData.book_parcel_model.Is_Forward)
      this.$refs.additionalReferences.reset()
      this.$refs.additionalInformations.reset()
    },
    cleanParcel () {
      this.$refs.generalInformation.reset()
      this.$refs.address.reset(this.bookingData.book_parcel_model.Is_Forward)
      this.$refs.additionalReferences.reset()
      this.$refs.additionalInformations.reset()
      this.reset()
      this.loadReferences()
    },

    see_Parcel_Details () {
      this.cleanParcel()
      this.$forceUpdate()
      if (this.parcel_id !== -1) {
        this.$router.push('/parcel-detail/' + this.parcel_id)
      }
    },

    // ************************ Generate a counter number for the parcel ************************

    nextStep () {
      this.currentStep += 1
      this.scrollToHeaderStep()
    },
    scrollToHeaderStep () {
      const activeHeaderStep = this.headerHolder.querySelectorAll('.spl-edit-template__step-header__step')[this.currentStep]
      this.headerHolder.scrollLeft = activeHeaderStep.offsetLeft + activeHeaderStep.offsetWidth / 2 - window.innerWidth / 2
    },
    showStep (index) {
      if (index === 0 || this.steps[index - 1].ref.isValid()) {
        this.currentStep = index
        this.scrollToHeaderStep()
      }
    },

    getNextStepLabel (step) {
      if (this.$mq === 'sm') {
        return step + 1 > this.steps.length - 1 ? 'Save' : 'Next'
      } else {
        return step + 1 > this.steps.length - 1 ? 'Save' : 'Next: ' + this.steps[step + 1].label
      }
    }
  }
}
</script>

<style lang="scss">
@import '../variables.scss';
.spl-next-button {
  float: right;
  margin-top: 60px;
}
.spl-book-parcel {
  & .spl-edit-template {
    margin-top: 10px;
    &__step:first-child {
      padding: 35px 70px;
    }
  }
}
@include mobile() {
  .spl-book-parcel {
    & .spl-edit-template {
      &__step-header-holder {
        display: none;
      }
      &__step:first-child,
      &__step {
        padding: 0px 10px 130px 10px;
        top: 60px;
        position: relative;
        width: calc(100%);
        height: auto;
        margin: 0;
      }
    }
  }
}
</style>
